import {useCallback, useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {mapOverlayPanes} from "base/component/geo";
import {useLayerObjectWithLegend} from "base/map";
import {NumberUtil} from "base/utilities";

export function useLayer(detail = false, fitBounds = false) {
    const navigate = useNavigate();
    const hoveredLayer = useRef(null);

    const clearHover = useCallback(layer => {
        layer.closeTooltip();
        layer.setStyle({opacity: 1, weight: 2, color: "#F79256"});
        if (hoveredLayer.current === layer) {
            hoveredLayer.current = null;
        }
    }, []);

    useEffect(() => {
        const clearIfOutside = event => {
            const layer = hoveredLayer.current;
            if (layer && !layer.getElement()?.contains(event.target)) {
                clearHover(layer);
            }
        };
        const clearOnLeave = () => {
            if (hoveredLayer.current) {
                clearHover(hoveredLayer.current);
            }
        };

        // Moving a polygon to the front can prevent Leaflet from receiving its mouseout.
        document.addEventListener("mousemove", clearIfOutside, true);
        document.addEventListener("mouseleave", clearOnLeave, true);
        window.addEventListener("blur", clearOnLeave);
        return () => {
            document.removeEventListener("mousemove", clearIfOutside, true);
            document.removeEventListener("mouseleave", clearOnLeave, true);
            window.removeEventListener("blur", clearOnLeave);
        };
    }, [clearHover]);

    return useLayerObjectWithLegend({
        legendOptions: {
            layerName: "Concellos",
            defaultMarkerOptions: {
                marker: "l",
                addStroke: false,
                fontSize: 35,
                weight: 2,
                color: "#F79256",
                fillOpacity: 0,
                opacity: 1,
                lineJoin: "round",
                pane: mapOverlayPanes[0],
            },
        },
        layerOptions: {
            detail: detail,
            fitBounds: fitBounds,
            getTooltip: ({feature}) => {
                let data = feature.properties;
                let tooltip = `<b>Concello: ${
                    data["nome"] ? data["nome"] : "---"
                }</b><ul class="attributes">`;
                tooltip += `<li><i>Poboación fixa</i>: ${
                    data["poboacion_fixa"]
                        ? `${NumberUtil.formatInteger(data["poboacion_fixa"])} habs.`
                        : "---"
                }</li>`;
                return tooltip + "</ul>";
            },
            getCustomMarkerOptions: ({options}) =>
                detail ? {...options, weight: 3, opacity: 1} : options,
            defaultOnClick: ({feature}) => navigate(`info/concellos/${feature.id}`),
            onMouseOver: ({layer}) => {
                if (hoveredLayer.current && hoveredLayer.current !== layer) {
                    clearHover(hoveredLayer.current);
                }
                hoveredLayer.current = layer;
                layer.setStyle({
                    opacity: 0.8,
                    weight: 4,
                    color: "#ff0000",
                });
                layer.bringToFront();
            },
            onMouseOut: ({layer}) => {
                clearHover(layer);
            },
        },
    });
}
